module.exports = __webpack_public_path__ + "img/success.b82b0f40.svg";